import React from 'react';
import { ImageTransformation } from '../../../../../../types';
import LazyImage from '../../../../../../components/lazyImage';

interface ImageProps {
  imageUrl: string | null;
  url: string | null;
  amplienceRoundel: string | null;
  className?: string;
}

// TODO remove me => use directly <LazyImage> inside Product component
function Image({ imageUrl, url, amplienceRoundel, className }: ImageProps): React.ReactElement {
  return (
    <>
      {url && <meta itemProp="image" content={url} />}
      <LazyImage
        src={imageUrl || ''}
        className={className}
        transformationTemplates={
          amplienceRoundel
            ? {
                1: [ImageTransformation.LOUNPLP, amplienceRoundel],
                2: [ImageTransformation.LOUNPLP_R, amplienceRoundel]
              }
            : { 1: ImageTransformation.LOUNPLP, 2: ImageTransformation.LOUNPLP_R }
        }
      />
    </>
  );
}

export default Image;
